import { z } from 'zod';

import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateEscrowPaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createEscrowPayment'),
  source: z.enum(['api', 'csv']),
  newMonthlyAmount: z.number(),
  effectiveDate: zodDateOrString,
});

export type CreateEscrowPaymentEvent = z.infer<typeof CreateEscrowPaymentEvent>;
